import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('ADVERTISING_GET_INITIAL_AGREEMENT'),
  ...AsyncRequest.createActionKeys('ADVERTISING_ACCEPT_AGREEMENT'),
  ...AsyncRequest.createActionKeys('GET_OPPORTUNITY_OWNERS'),
  ...AsyncRequest.createActionKeys('FETCH_AGREEMENTS_BY_SERVICE_PROVIDER_ID'),
};



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/advertising-gateway/advertisingActionKeys.js